import React, { ButtonHTMLAttributes } from "react";
import { ArrowIcon, ButtonContent, StyledButton } from "./Button.styles";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "arrow";
  outlined?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  variant = "default",
  outlined = false,
  type = "button",
  ...props
}) => {
  return (
    <StyledButton
      type={type}
      $withArrow={variant === "arrow"}
      $outlined={outlined}
      {...props}
    >
      <ButtonContent $withArrow={variant === "arrow"} $outlined={outlined}>
        {children}
      </ButtonContent>
      {variant === "arrow" && (
        <ArrowIcon $outlined={outlined} aria-hidden="true">
          <i className="pi pi-arrow-up-right" />
        </ArrowIcon>
      )}
    </StyledButton>
  );
};

export default Button;
